
<template>
    <div class="web-skill-ranking-container">
        <template v-if="loading">
            <WebSkillRankingSkeleton />
        </template>
        <template v-else>
            <el-main class="ranking-content">
                <WebSkillRankingHeader />
                <MetaTitleSection />
                <MetaSection />
                <WebSkillRankingTable />
            </el-main>
        </template>
    </div>
</template>

<script>
import { useWebSkillRankingStore } from "@/stores/WebSkillRankingStore";
import { mapStores } from "pinia";

import WebSkillRankingSkeleton from "./Components/WebSkillRankingSkeleton.vue";
import WebSkillRankingHeader from "./Components/WebSkillRankingHeader.vue";
import WebSkillRankingTable from "./Components/WebSkillRankingTable.vue";
import MetaTitleSection from "./Components/MetaTitleSection.vue";
import MetaSection from "./Components/MetaSection.vue";

export default {
    name: "WebSkillRankingEdit",
    components: {
        WebSkillRankingSkeleton,
        WebSkillRankingHeader,
        WebSkillRankingTable,
        MetaTitleSection,
        MetaSection,
    },
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        ...mapStores(useWebSkillRankingStore),
    },
    methods: {
        async fetchData() {
            const pathParts = window.location.pathname.split('/');
            const rankingId = pathParts[pathParts.length - 2]; 

            if (rankingId) {
                this.loading = true;
                try {
                    await this.WebSkillRankingStore.fetchWebSkillRankingData(rankingId);
                } catch (error) {
                    console.error(error);
                } finally {
                    this.loading = false;
                }
            }
        },
    },
    created() {
        this.fetchData();
    },
};
</script>

<style>
.web-skill-ranking-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}
.ranking-content {
    display: flex;
    flex-direction: column;
    padding: 20px;
    flex-grow: 1;
    overflow-y: auto;
    min-height: 0;
}
</style>